import { render, staticRenderFns } from "./BasWarehouseModal.vue?vue&type=template&id=53737934&scoped=true&"
import script from "./BasWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./BasWarehouseModal.vue?vue&type=script&lang=js&"
import style0 from "./BasWarehouseModal.vue?vue&type=style&index=0&id=53737934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53737934",
  null
  
)

export default component.exports